import React, { useMemo } from "react";
import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
import { getDataTableSerialNumber } from "helpers/datatable";

const useDataTableColumns = (columns = [], className = "", checkboxSelection = false, hasIterator = true) => {
    const data = useMemo(
        () => {
            return [
                ...(checkboxSelection
                    ? [
                          {
                              ...GRID_CHECKBOX_SELECTION_COL_DEF,
                              width: 50,
                              flex: 0,
                              headerClassName: className,
                          },
                      ]
                    : []),
                ...(hasIterator
                    ? [
                          {
                              field: "id",
                              headerName: "#",
                              flex: 0,
                              headerClassName: className,
                              headerAlign: "center",
                              filterable: false,
                              renderCell: getDataTableSerialNumber,
                              valueGetter: getDataTableSerialNumber,
                              maxWidth: 40,
                              align: "center",
                          },
                      ]
                    : []),
                ...columns,
            ].map((r) => (r.align == undefined && !["actions", "id"].includes(r.type) ? { ...r, align: "left" } : r));
        },
        [columns, hasIterator, className]
    );

    return data;
};

export default useDataTableColumns;
